"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
interface BathroomsSectionProps {
  value: number | null;
  onChange: (value: number | null) => void;
  minAllowed?: number;
}
const BATHROOM_OPTIONS = [{
  value: 1,
  label: "1+"
}, {
  value: 2,
  label: "2+"
}, {
  value: 3,
  label: "3+"
}, {
  value: 4,
  label: "4+"
}, {
  value: 5,
  label: "5+"
}, {
  value: 6,
  label: "6+"
}, {
  value: 7,
  label: "7+"
}, {
  value: 8,
  label: "8+"
}];
export function BathroomsSection(t0) {
  const $ = _c(6);
  const {
    value,
    onChange,
    minAllowed: t1
  } = t0;
  const minAllowed = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== minAllowed || $[1] !== onChange || $[2] !== value) {
    t2 = BATHROOM_OPTIONS.map((option, index) => {
      const isSelected = value === option.value;
      const isDisabled = option.value < minAllowed;
      return <button type="button" key={option.value} onClick={() => {
        onChange(isSelected ? null : option.value);
      }} disabled={isDisabled} className={cn("py-3 text-sm font-medium transition-colors", "flex-shrink-0 min-w-[60px] md:flex-1 md:min-w-0", index === 0 && "rounded-l-xl", index === BATHROOM_OPTIONS.length - 1 && "rounded-r-xl", index > 0 && "border-l border-gray-300", "px-4 py-3 text-body shadow-sm hover:bg-neutral-300 cursor-pointer", isDisabled ? "opacity-50 cursor-not-allowed bg-gray-100" : "cursor-pointer", isSelected ? "bg-primary-400 text-primary-600" : "bg-white text-gray-600 hover:bg-gray-50")}>{option.label}</button>;
    });
    $[0] = minAllowed;
    $[1] = onChange;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex border border-gray-300 rounded-xl overflow-hidden md:overflow-x-visible overflow-x-auto">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}